<template>
  <div id="lobbies-view">
    <div id="lobbies-join-wrapper" class="lobbies-wrapper">
      <h1>join a lobby</h1>
      <div id="public-lobbies-wrapper">
        <div class="public-lobby" v-for="lobby in lobbies" :key="lobby">
          <p>{{ lobby.name }}</p>
          <p>{{ lobby.players.length }} players</p>
          <button @click="joinLobby(lobby.id)">join</button>
        </div>
      </div>
    </div>
    <div class="lobbies-wrapper">
      <h1>create a lobby</h1>
      <div id="lobbies-create-wrapper">
        <input v-model="lobbyName" />
        <button>create lobby</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LobbiesView',
  data () {
    return {
      lobbies: [],
      lobbyName: 'lobby name'
    }
  },
  methods: {
    async getLobbies () {
      return await fetch(window.location.origin + '/api/lobbies');
    },
    setLobbies () {
      this.getLobbies().then(res => res.json()).then(lobbies => {
        console.log(lobbies);
        this.lobbies = lobbies;
      });
    },
    joinLobby (id) {
      window.location.href = window.location.origin + `/lobby?id=${id}`;
    }
  },
  mounted () {
    this.setLobbies()
    setInterval(() => {
      this.setLobbies();
    }, 10000);
  }
}
</script>

<style scoped>
#lobbies-view {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: space-around;
  align-items: center;
}

#public-lobbies-wrapper {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .2);
  overflow-y: auto;

  display: flex;
  flex-direction: column;
}

#lobbies-create-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.public-lobby {  
  width: calc(100% - 1rem);
  height: 2rem;
  padding: .5rem;
  background-color: rgba(0, 0, 0, .05);

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.public-lobby:nth-child(even) {
  background-color: rgba(0, 0, 0, .1);
}

.lobbies-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40vw;
  height: 70vh;
}
</style>